function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _require = require('../../utils/domUtils'),
    setAttributes = _require.setAttributes,
    setStyle = _require.setStyle;

function wixProGalleryWrapper(WixElement, services) {
  var getItemWrapperStyle = function getItemWrapperStyle(item, styleParams) {
    return {
      width: item.width,
      height: item.height + (styleParams.externalInfoHeight || 0)
    };
  };

  var getItemContainerStyle = function getItemContainerStyle(item, styleParams) {
    var itemWrapperStyles = getItemWrapperStyle(item, styleParams);
    var isRTL = styleParams.isRTL;
    return _objectSpread({
      opacity: 1,
      top: item.offset.top,
      left: isRTL ? 'auto' : item.offset.left,
      right: !isRTL ? 'auto' : item.offset.left
    }, itemWrapperStyles);
  };

  var WixProGallery =
  /*#__PURE__*/
  function (_WixElement) {
    _inheritsLoose(WixProGallery, _WixElement);

    function WixProGallery() {
      var _this;

      // eslint-disable-line no-useless-constructor
      _this = _WixElement.call(this) || this;
      import(
      /* webpackChunkName: "pro-layouts" */
      'pro-layouts').then(function (module) {
        _this.createLayout = module.createLayout;

        if (_this.measures && !_this.layout) {
          _this.reLayout();
        }
      });
      return _this;
    }

    var _proto = WixProGallery.prototype;

    _proto.reLayout = function reLayout() {
      var _this2 = this;

      this.parentId = this.dataset.parentId;
      this.parent = this.parentId && document.getElementById(this.parentId);

      if (!this.parent) {
        return;
      }

      this.useLayouter = true;
      this.items = this.dataset.items && JSON.parse(this.dataset.items.replace(/'/g, '"'));

      if (!(this.items && this.items.length > 0)) {
        this.useLayouter = false;
      }

      this.styleParams = this.dataset.options && JSON.parse(this.dataset.options.replace(/'/g, '"'));

      if (!(this.styleParams && typeof this.styleParams === 'object')) {
        this.useLayouter = false;
      }

      services.mutationService.measure(function () {
        _this2.measures = _this2.parent.getBoundingClientRect();

        if (_this2.useLayouter && typeof _this2.createLayout === 'function') {
          _this2.layout = _this2.createLayout({
            items: _this2.items,
            styleParams: _this2.styleParams,
            container: _this2.measures
          });
        }
      });
      services.mutationService.mutate(function () {
        if (typeof _this2.measures === 'object') {
          setAttributes(_this2.parent, {
            'data-top': _this2.measures.top,
            'data-width': _this2.measures.width,
            'data-height': _this2.measures.height
          });
        }

        if (_this2.useLayouter && _this2.layout && _this2.layout.items && _this2.layout.items.length > 0) {
          _this2.parent.querySelectorAll('.gallery-item-container').forEach(function (element, idx) {
            setStyle(element, getItemContainerStyle(_this2.layout.items[idx], _this2.styleParams));
          });

          _this2.parent.querySelectorAll('.gallery-item-wrapper').forEach(function (element, idx) {
            setStyle(element, getItemWrapperStyle(_this2.layout.items[idx], _this2.styleParams));
          });
        }
      });
    };

    _proto.connectedCallback = function connectedCallback() {
      if (typeof this.dataset.observeResize !== 'undefined') {
        _WixElement.prototype.connectedCallback.call(this);
      } else {
        this.reLayout();
      }
    };

    return WixProGallery;
  }(WixElement);

  return WixProGallery;
}

module.exports = wixProGalleryWrapper;
//# sourceMappingURL=wixProGallery.js.map